import DateRangePicker from "~/components/input/selects/DateRangePicker.jsx";

export default function MetabaseDateRangePicker({ appProps, maxDate = new Date(), value, originalValue, onChange }) {
    return (
        <DateRangePicker
            label="Dates"
            tooltipTitle={""}
            tooltip={"The data is updated every morning. Therefor today's data is not selectable to avoid incorrect data."}
            originalValue={originalValue}
            value={value}
            onChange={onChange}
            showCloseButton={true}
            closeButtonToOriginalValue
            appProps={appProps}
            maxDate={maxDate}
        />
    );
}
